module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/order/order.component.scss
// module id = ./src/app/pages/order/order.component.scss
// module chunks = main